<template>
  <v-row no-gutters class="mx-auto my-3">
    <v-col cols="12" class="mb-4 d-flex flex-wrap">
      <div v-for="(item, index) in designObject" :key="index">
        <div @click="chooseDesign(item.value)" class="m-2 p-3 qrBtn">
          <img :src="item.img" :alt="item.value">
        </div>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="pa-2">
      <color-picker v-model="marker.main" label="رنگ مرکز"/>
    </v-col>

    <v-col cols="12" md="6" class="pa-2">
      <v-switch label="شخصی سازی مارکر" v-model="marker.different_markers_color" class="ma-2"/>
    </v-col>

    <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
      <color-picker v-model="marker.topRight" label="بالا راست"/>
    </v-col>

    <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
      <color-picker v-model="marker.bottomLeft" label="پایین چپ"/>
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrMarkOut",
  components: {ColorPicker},
  data() {
    return {
      designObject: [
        {value: 'circle', img: '/media/markOut/circle.svg'},
        {value: 'default', img: '/media/markOut/default.svg'},
        {value: 'drop', img: '/media/markOut/drop.svg'},
        {value: 'dropeye', img: '/media/markOut/dropeye.svg'},
        {value: 'dropeyeleaf', img: '/media/markOut/dropeyeleaf.svg'},
        {value: 'dropeyeleft', img: '/media/markOut/dropeyeleft.svg'},
        {value: 'dropeyerightt', img: '/media/markOut/dropeyerightt.svg'},
        {value: 'drop_in', img: '/media/markOut/drop_in.svg'},
        {value: 'flower', img: '/media/markOut/flower.svg'},
        {value: 'flower_in', img: '/media/markOut/flower_in.svg'},
        {value: 'flurry', img: '/media/markOut/flurry.svg'},
        {value: 'leaf', img: '/media/markOut/leaf.svg'},
        {value: 'rounded', img: '/media/markOut/rounded.svg'},
        {value: 'sdoz', img: '/media/markOut/sdoz.svg'},
        {value: 'squarecircle', img: '/media/markOut/squarecircle.svg'},
      ],
      marker: {
        topRight: '#000',
        bottomLeft: '#000',
        markOutPattern: 'default',
        main: '#000',
        different_markers_color: false
      },
    }
  },
  methods: {
    chooseDesign(value) {
      this.marker.markOutPattern = value;
    }
  },
  watch: {
    marker: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #02105c8c;
  cursor: pointer;
}

.qrBtn:hover {
  border-radius: 0 !important;
  box-shadow: none !important;
}
</style>